import { ArrowRight, Filter, Search, Calendar, List, Grid } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../incomeGrid.module.css";
import FilterAutocomplete from "../../../../../../components/FilterAutocomplete";

// Same buckets as the rent roll balance: 0 = Outstanding (> 0), 1 = Balance (= 0), 2 = Over Paid (< 0)
const PAYMENT_STATUS_OPTIONS = [
  { value: 0, label: "Outstanding" },
  { value: 1, label: "Balance" },
  { value: 2, label: "Over Paid" },
];

const GridFilters = ({ setPage, setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, handleView }) => {
  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => {
          setFilterData((prev) => {
            return { ...prev, searchKey: e.target.value };
          });
          setPage(0);
        }} />
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}><ArrowRight /></span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Property"
            options={propertyList}
            value={filterData?.property}
            onChange={(value) => {
              // The apartment filter belongs to the previous property, so clear it
              setFilterData((prev) => ({ ...prev, property: value, apartment: "" }));
              selectProperty(value);
              setPage(0);
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Apartment"
            options={apartmentList}
            value={filterData?.apartment}
            noOptionsText={filterData?.property !== "" ? "No apartments" : "Select Property First"}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, apartment: value }));
              setPage(0);
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Payment Status"
            options={PAYMENT_STATUS_OPTIONS}
            value={filterData?.payment_status}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, payment_status: value }));
              setPage(0);
            }}
          />
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, last_payment_date: date };
                });
                setPage(0);
              }}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        <div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} `} onClick={() => handleView("list")}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <Grid /> <span>Grid</span>
          </div>
        </div>
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
}

export default GridFilters;